'use strict';

var _ = require('lodash');
var SeasonRibbonDataProviderService = function SeasonRibbonDataProviderService($q, retrieverConstants, dataRetrieverService, featureToggleService) {
  function retrieveData(market, calendarName, calendarModeLabel) {
    var m = market.split('-');
    var rqlQuery = 'origin==' + m[0] + ';destination==' + m[1] + ';calendarName=="' + calendarName + '"';
    var isPooledDemandCalendar = calendarModeLabel === 'Demand' && featureToggleService.isEnabled('POOLED_SEASONALITY');
    var screen = isPooledDemandCalendar ? retrieverConstants.SEASONALITY_ANALYSIS_CHART_HISTORICAL_POOLED : retrieverConstants.SEASONALITY_ANALYSIS_CHART_HISTORICAL;
    return dataRetrieverService.getDataRetriever(retrieverConstants.SEASONALITY_SCREEN, screen).setCustomSearchCriteriaRules($q.when(rqlQuery)).localSortApplied().retrieveComponentData(screen);
  }
  function getVariance(group) {
    var dataPoints = _.map(group, 'weeklyDataPointValue');
    var mean = _.mean(dataPoints);
    var sum = _.chain(dataPoints).map(function (d) {
      return Math.pow(d - mean, 2);
    }).sum().value();
    return (sum / dataPoints.length).toFixed(2);
  }
  function getDowsCaption(dows) {
    return _.chain(dows).map(function (dow) {
      var singleLetterAbbreviation = dow === 'Mon' || dow === 'Wed' || dow === 'Fri';
      return dow.substring(0, singleLetterAbbreviation ? 1 : 2);
    }).join(', ').value();
  }
  function applyOverrides(dataPoints, overrides) {
    _.forEach(overrides, function (override) {
      _.chain(dataPoints).filter({
        dowGroup: override.dowGroup,
        week: override.weekNo
      }).forEach(function (dataPoint) {
        dataPoint.season = override.season;
      }).value();
    });
  }
  function getSpecialEvents(data) {
    return data && data.length ? data[0].specialEvents : [];
  }
  function transformDataForSOW(data, spos, classGroup, overrides) {
    return transformData(data, spos, classGroup, overrides);
  }
  function transformData(data, spos, classGroup, overrides) {
    var sposClassGroupData = _.cloneDeep(_.filter(data.outputs, {
      classGroup: classGroup,
      spos: spos
    }));
    if (!sposClassGroupData || sposClassGroupData.length < 1) {
      return undefined;
    }
    var overrideGroupData = _.filter(overrides, {
      classGroup: classGroup,
      significantPOS: spos,
      year: undefined
    });
    var dataPoints = [];
    _.forEach(sposClassGroupData, function (entry) {
      dataPoints = _.concat(dataPoints, entry.weeklyDataPoints);
    });
    applyOverrides(dataPoints, overrideGroupData);
    return _.chain(dataPoints).sortBy('week').reduce(function (result, d) {
      if (!_.isArray(result[d.season + d.dowGroup])) {
        result[d.season + d.dowGroup] = [];
      }
      result[d.season + d.dowGroup].push(d);
      return result;
    }, {}).map(function (group) {
      var firstInGroup = group[0];
      var groupDefinition = _.find(data.dowGroups, {
        group: firstInGroup.dowGroup
      });
      return {
        season: firstInGroup.season,
        seasonCluster: firstInGroup.seasonCluster,
        dowGroup: getDowsCaption(groupDefinition.dow),
        departureDates: group.length * groupDefinition.dow.length,
        variance: getVariance(group)
      };
    }).orderBy(['seasonCluster', 'departureDates'], ['asc', 'desc']).value();
  }
  function getData(market, calendarName, calendarModeLabel) {
    return retrieveData(market, calendarName, calendarModeLabel);
  }
  return {
    getData: getData,
    transformDataForSOW: transformDataForSOW,
    getSpecialEvents: getSpecialEvents
  };
};
SeasonRibbonDataProviderService.$inject = ['$q', 'DataRetrieverConstantsService', 'DataRetrieverService', 'FeatureToggleService'];
module.exports = SeasonRibbonDataProviderService;